import type {
    CompanyValue,
    CreateCompanyValueRequest,
    UpdateCompanyValueRequest,
} from '@/types/company-values';

import { api } from '@/api/api';

export default {
    async getCompanyValues(): Promise<CompanyValue[]> {
        const response = await api.get('/CompanyValue');
        return response.data;
    },

    async getCompanyValueById(id: string): Promise<CompanyValue> {
        const response = await api.get(`/CompanyValue/${id}`);
        return response.data;
    },

    async createCompanyValue(request: CreateCompanyValueRequest): Promise<CompanyValue> {
        const response = await api.post('/CompanyValue', request);
        return response.data;
    },

    async updateCompanyValue(
        id: string,
        request: UpdateCompanyValueRequest,
    ): Promise<CompanyValue> {
        const response = await api.put(`/CompanyValue/${id}`, request);
        return response.data;
    },

    async deleteCompanyValue(id: string): Promise<CompanyValue> {
        const response = await api.delete(`/CompanyValue/${id}`);
        return response.data;
    },

    async toggleCompanyValueStatus(id: string): Promise<CompanyValue> {
        const response = await api.patch(`/CompanyValue/${id}/ToggleStatus`);
        return response.data;
    },

    async getCompanyValueImpactCounts(id: string) {
        const response = await api.get(`/CompanyValue/${id}/ImpactCounts`);
        return response.data;
    },
};
